import { createAction, props } from '@ngrx/store';
import { IPaymentFraction, IPaymentFractionState } from './paymentFractions.models';
 
export const setPaymentFractionState = createAction(
    '[PaymentFractions] Set PaymentFraction State',
    props<{ new_state: IPaymentFractionState }>()
);

export const setPaymentFractions = createAction(
    '[PaymentFractions] Set PaymentFractions',
    props<{ paymentFractions: IPaymentFraction[] }>()
);

export const selectPaymentFraction = createAction(
    '[PaymentFractions] Select PaymentFraction',
    props<{ paymentFractionSelected: IPaymentFraction }>()
);